export function BrandMark({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="miter"
      aria-hidden="true"
    >
      <path d="M12 3 L21 19 L3 19 Z" />
      <path d="M12 8 L17.5 17.5 L6.5 17.5 Z" />
      <path d="M12 12 L14.5 16.5 L9.5 16.5 Z" />
    </svg>
  );
}
